import TaskTable from "./TaskTable";
import { Card } from "@mui/material";

const ArchivedTasksTab = ({
	tasks,
	t,
	editTask,
	toggleDialogIsOpen,
	setDialogType,
	setDialogData,
	deleteTask,
	resetDialogData,
	copyTask,
}) => {
	return (
		<Card sx={{ p: 3, height: "calc(100vh - 120px)", width: "100%" }}>
			<TaskTable
				tasks={tasks}
				t={t}
				editTask={editTask}
				toggleDialogIsOpen={toggleDialogIsOpen}
				setDialogType={setDialogType}
				setDialogData={setDialogData}
				deleteTask={deleteTask}
				resetDialogData={resetDialogData}
				copyTask={copyTask}
			/>
		</Card>
	);
};

export default ArchivedTasksTab;
